import DevChampsResultListRs, { DevChampsResultDto } from '@domain/rs/dchamps/DevChampsResultListRs';
import DateFormat from '@utils/date/format';

export default class DevChampsResultListVO {
  results: DevChampsResultVO[];

  constructor(rs: DevChampsResultListRs) {
    this.results = rs.results.map((result) => new DevChampsResultVO(result));
  }
}

class DevChampsResultVO {
  devChampsSn: number; //디챔스 sn
  title: string; //결과표 제목
  paccEndDateTime: string | null; //개발자 역량검사 완료 시간
  pstEndDateTime: string | null; //개구검 완료 시간

  constructor(dto: DevChampsResultDto) {
    this.devChampsSn = dto.devChampsSn;
    this.title = dto.title;
    this.paccEndDateTime = dto.paccEndDateTime
      ? DateFormat.format(new Date(dto.paccEndDateTime), 'yyyy.MM.dd HH:mm')
      : null;
    this.pstEndDateTime = dto.pstEndDateTime
      ? DateFormat.format(new Date(dto.pstEndDateTime), 'yyyy.MM.dd HH:mm')
      : null;
  }
}
